import {
    AI_OUTREACH_API_DOCS_URL,
    CONTACTS_VIEW_CENTER_URL,
    LEAD_ENRICHMENT_MANUAL_URL,
    SIGNALS_REST_API_DOCS_URL,
    TECHNOLOGY_API_URL,
} from "app/pages/sales-intelligence/modules/management/sub-modules/constants";

import type { ApiPageType, IAPIItem } from "../types/api-page-type";

import {
    MANAGE_INTEGRATIONS_CARD_ENGAGEMENT_TAG,
    MANAGE_INTEGRATIONS_CARD_ENRICHMENT_TAG,
    MANAGE_INTEGRATIONS_CARD_PROSPECTING_TAG,
    MY_INTEGRATIONS_API_AI_OUTREACH_DESCRIPTION,
    MY_INTEGRATIONS_API_AI_OUTREACH_TITLE,
    MY_INTEGRATIONS_API_CONTACTS_DESCRIPTION,
    MY_INTEGRATIONS_API_CONTACTS_TITLE,
    MY_INTEGRATIONS_API_LEAD_ENRICHMENT_DESCRIPTION,
    MY_INTEGRATIONS_API_LEAD_ENRICHMENT_TITLE,
    MY_INTEGRATIONS_API_SIGNALS_REST_API_DESCRIPTION,
    MY_INTEGRATIONS_API_SIGNALS_REST_API_TITLE,
    MY_INTEGRATIONS_API_TECHNOLOGIES_DESCRIPTION,
    MY_INTEGRATIONS_API_TECHNOLOGIES_TITLE,
} from "./translations";

export const API_ITEMS_CONFIGS: Record<ApiPageType, { hookId: string; tutorialLink: string }> = {
    technologies: {
        hookId: "TechnologiesApiHook",
        tutorialLink: TECHNOLOGY_API_URL,
    },
    leadEnrichment: {
        hookId: "LeadEnrichmentApiHook",
        tutorialLink: LEAD_ENRICHMENT_MANUAL_URL,
    },
    contacts: {
        hookId: "ContactsApiHook",
        tutorialLink: CONTACTS_VIEW_CENTER_URL,
    },
    aiOutreach: {
        hookId: "AIOutreachApiHook",
        tutorialLink: AI_OUTREACH_API_DOCS_URL,
    },
    signalsRestApi: {
        hookId: "SignalsRestApiHook",
        tutorialLink: SIGNALS_REST_API_DOCS_URL,
    },
};

export const API_ITEMS: IAPIItem[] = [
    {
        name: "technologies",
        dataAutomation: "technologies-api-card",
        titleKey: MY_INTEGRATIONS_API_TECHNOLOGIES_TITLE,
        descriptionKey: MY_INTEGRATIONS_API_TECHNOLOGIES_DESCRIPTION,
        price: { key: "10" },
        labels: [MANAGE_INTEGRATIONS_CARD_ENRICHMENT_TAG],
        tutorialLink: API_ITEMS_CONFIGS.technologies.tutorialLink,
    },
    {
        name: "leadEnrichment",
        dataAutomation: "lead-enrichment-api-card",
        titleKey: MY_INTEGRATIONS_API_LEAD_ENRICHMENT_TITLE,
        descriptionKey: MY_INTEGRATIONS_API_LEAD_ENRICHMENT_DESCRIPTION,
        price: { key: "si.common.number-max", replacements: { value: 35 } },
        labels: [MANAGE_INTEGRATIONS_CARD_ENRICHMENT_TAG],
        tutorialLink: API_ITEMS_CONFIGS.leadEnrichment.tutorialLink,
    },
    {
        name: "contacts",
        dataAutomation: "contacts-api-card",
        titleKey: MY_INTEGRATIONS_API_CONTACTS_TITLE,
        descriptionKey: MY_INTEGRATIONS_API_CONTACTS_DESCRIPTION,
        price: { key: "~25" },
        labels: [MANAGE_INTEGRATIONS_CARD_ENRICHMENT_TAG],
        tutorialLink: API_ITEMS_CONFIGS.contacts.tutorialLink,
    },
    {
        name: "aiOutreach",
        dataAutomation: "ai-outreach-api-card",
        titleKey: MY_INTEGRATIONS_API_AI_OUTREACH_TITLE,
        descriptionKey: MY_INTEGRATIONS_API_AI_OUTREACH_DESCRIPTION,
        price: { key: "10" },
        labels: [MANAGE_INTEGRATIONS_CARD_ENGAGEMENT_TAG],
        tutorialLink: API_ITEMS_CONFIGS.aiOutreach.tutorialLink,
    },
];
